<script setup>
    import { isClient } from '@vueuse/core';
    import { computed, provide } from 'vue';

    import { urlSearchParams } from '@resn/gozer-misc';
    import { TweakPane } from '@resn/gozer-vue';

    import GlobalWrapper from '~/components/GlobalWrapper.vue';

    const hideTweakPane = computed(() =>
        isClient ? urlSearchParams.get('hidepane') == 'true' : false
    );

    provide('sandbox', true);
</script>

<template>
    <TweakPane :hiddenOnStart="hideTweakPane">
        <GlobalWrapper>
            <div class="layout-sandbox">
                <slot />
            </div>
        </GlobalWrapper>
    </TweakPane>
</template>
